<template>
  <div class="home" ref="scrollContainer">
    <div class="header">
      <div class="header-container">
        <div class="header-top">
          <div class="logo">
            <img src="../assets/logo@2x.png" alt="" />
            <span>正规持牌机构旗下智能金融服务平台</span>
          </div>
          <div class="nav">
            <span
              class="nav-item"
              v-for="(item, key) in navList"
              :key="key"
              @click="handleChangeTab(key)"
              :class="currentIndex == key ? 'active' : ''"
              >{{ item }}</span
            >
          </div>
        </div>
        <div class="purpose">
          <div class="sub-1">聚享好借</div>
          <div class="sub-2">智选无忧</div>
          <div class="sub-3">产品丰富｜申请便捷｜安全合规｜极速批核</div>
        </div>
      </div>
    </div>
    <div class="about-us">
      <img src="../assets/bg-2@2x.png" alt="" />
      <div class="about-text">
        <div class="title">关于我们</div>
        <div class="content">
          广州市聚富互联网小额贷款有限公司专注于满足金融行业的数智化需求，有效提升数智金融服务效率，为个人用户及小微企业提供安全、高效、智能的一站式金融服务。
        </div>
        <div class="content">
          聚好借是聚富小贷旗下智选金融综合服务平台，以申请流程便捷、严格的安全合规标准、透明的息费结构以及丰富的产品选择等优势，赢得了广大用户的信赖。
        </div>
      </div>
    </div>
    <div class="application-steps">
      <div class="title">申请步骤</div>
      <div class="step-bg"></div>
      <div class="step-img">
        <img src="../assets/real-name-1@2x.png" alt="" />
        <img src="../assets/real-name-2@2x.png" alt="" />
        <img src="../assets/real-name-3@2x.png" alt="" />
      </div>
    </div>
    <div class="contact-us">
      <div class="contact">
        <div class="left">
          <div class="title">联系我们</div>
          <div class="text">客服邮箱：service@jfloan.com</div>
          <div class="text">工作时间：工作日 09:00-18:00</div>
          <div class="text">监督电话：020-12345</div>
        </div>
        <div class="right">
          <div class="weixin">
            <img src="../assets/weixin-QR-code@2x.png" alt="" />
            <div class="text">聚富小贷公众号</div>
          </div>
          <div class="down-load">
            <img src="../assets/download-code@2x.png" alt="" />
            <div class="text">扫一扫下载聚好借</div>
          </div>
        </div>
      </div>
      <img src="../assets/line@2x.png" alt="" class="border" />
      <div class="risk">
        贷款有风险,借款需谨慎; 请根据个人能力合理贷款,理性消费,避免逾期
      </div>
      <div class="copyright">
        <span>Copyright © 广州市聚富互联网小额贷款有限公司</span>
        <span @click="handleGoCopyright(1)">粤ICP备17137794号</span>
        <span @click="handleGoCopyright(2)"
          ><img src="../assets/police-badge@2x.png" alt="" />粤公网安备
          44010402001306号</span
        >
      </div>
    </div>
    <div class="down-load-pop" v-show="showPop">
      <div class="pop-content">
        <img src="../assets/close@2x.png" alt="" @click="showPop = false" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HomeCom",
  data() {
    return {
      currentIndex: 0,
      navList: ["首页", "关于我们", "App 下载"],
      showPop: false,
    };
  },
  methods: {
    handleChangeTab(key) {
      this.currentIndex = key;
      switch (key) {
        case 0:
          this.scrollToPosition(0);
          break;
        case 1:
          this.scrollToPosition(800);
          break;
        case 2:
          this.showPop = true;
          break;
      }
    },
    scrollToPosition(position) {
      const element = this.$refs.scrollContainer;
      if (element) {
        element.scrollTo({
          top: position,
          behavior: "smooth",
        });
      }
    },
    handleGoCopyright(type) {
      switch (type) {
        case 1:
          window.location.href = "https://beian.miit.gov.cn";
          break;
        case 2:
          window.location.href =
            "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44010402001306";
          break;
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.home {
  width: 1920px;
  height: fit-content;
  text-align: center;
  background: #f7f7f7;
  overflow: auto;
  max-height: 100vh;
  position: relative;
  .header {
    width: 100%;
    height: 1174px;
    background-image: url("../assets/bg-1@2x.png");
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    .header-container {
      width: 100%;
      height: 100%;
      padding: 30px 160px 0;
      box-sizing: border-box;
      background-color: rgba(0, 0, 0, 0.4);
      .header-top {
        display: flex;
        justify-content: space-between;
        align-items: baseline;
        .logo {
          img {
            height: 61px;
            vertical-align: bottom;
          }
          span {
            display: inline-block;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 21px;
            color: #ffffff;
            margin-left: 17px;
            margin-bottom: 3px;
          }
        }
        .nav {
          width: 370px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .nav-item {
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 24px;
            color: #ffffff;
            cursor: pointer;
          }
          .active {
            position: relative;
            &::after {
              display: inline-block;
              content: "";
              position: absolute;
              bottom: -8px;
              left: 0;
              width: 100%;
              height: 3px;
              background: #ffffff;
              border-radius: 2px;
            }
          }
        }
      }
    }
    .purpose {
      margin-top: 248px;
      text-align: left;
      width: max-content;
      div {
        text-align: center;
      }
      .sub-1,
      .sub-2 {
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 120px;
        color: #ffffff;
        margin-top: -28px;
      }
      .sub-3 {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 24px;
        color: #ffffff;
      }
    }
  }
  .about-us {
    width: calc(100% - 320px);
    height: 654px;
    background: #ffffff;
    border-radius: 40px;
    padding: 93px 63px;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    margin: -241px 160px 0;
    box-sizing: border-box;
    .title {
      margin-bottom: 26px;
    }
    img {
      width: 700px;
      margin-right: 64px;
      margin-top: 9px;
    }
    .content {
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 28px;
      color: #a4a4a4;
      line-height: 50px;
      text-align: justify;
      &:last-child {
        margin-top: 28px;
      }
    }
  }
  .application-steps {
    width: calc(100% - 320px);
    margin: 106px 160px 0;
    box-sizing: border-box;
    .title {
      margin-bottom: 40px;
    }
    .step-bg {
      width: 100%;
      height: 491px;
      background: url("../assets/rectangle-bg@2x.png") no-repeat center;
      background-size: 100% 100%;
    }
    .step-img {
      margin-top: -346px;
      padding: 0 81px;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      img {
        width: 443.87px;
      }
    }
  }
  .contact-us {
    margin-top: -93px;
    width: 100%;
    height: 743px;
    background: #2b2b2b;
    padding: 80px 64px;
    box-sizing: border-box;
    position: absolute;
    z-index: 1;
    .contact {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      padding: 0 96px 70px;
      box-sizing: border-box;
      .left {
        .title {
          margin-bottom: 42px;
        }
        .text {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 32px;
          color: #ffffff;
          line-height: 45px;
          text-align: left;
          margin-top: 12px;
          &:first-child {
            margin-top: 0;
          }
        }
      }
      .right {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        padding-top: 45px;
        img {
          width: 240px;
        }
        .text {
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          font-size: 26px;
          color: #ffffff;
          line-height: 37px;
          margin-top: 17px;
        }
        .weixin {
          margin-right: 123px;
        }
      }
    }
    .border {
      width: 1792px;
      height: 1px;
    }
    .risk {
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 24px;
      color: #ffffff;
      line-height: 33px;
      margin: 94px 0 12px;
    }
    .copyright {
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 24px;
      color: #ffffff;
      line-height: 33px;
      span {
        margin-right: 30px;
        &:nth-child(2),
        &:nth-child(3) {
          cursor: pointer;
        }
        &:last-child {
          margin-right: 0;
        }
      }
      img {
        height: 24px;
        margin-right: 4px;
        vertical-align: middle;
        margin-bottom: 4px;
      }
    }
  }
  .title {
    width: fit-content;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 60px;
    color: #fa475f;
    padding-left: 28px;
    position: relative;
    &::before {
      content: "";
      display: inline-block;
      position: absolute;
      top: 16px;
      left: 0px;
      width: 5px;
      height: 52px;
      background: #fa475f;
    }
  }
  .down-load-pop {
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.52);
    padding-top: 237px;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    position: absolute;
    transition: all 0.2s;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    .pop-content {
      width: 1350px;
      height: 700px;
      background: url("../assets/download-app@2x.png") no-repeat center;
      background-size: 100% 100%;
      padding-top: 40px;
      padding-right: 45px;
      text-align: right;
      img {
        width: 36.77px;
        cursor: pointer;
      }
    }
  }
}
</style>
